export const HolidayTypes = {
  Public: { label: 'Public', value: 'Public' },
  Optional: { label: 'Optional', value: 'Optional' },
  CompanySpecific: { label: 'Company-Specific', value: 'CompanySpecific' },
};
